import useFormatCurrency from './useFormatCurrency';

function useConvertCentsToEur() {
  const formatCurrency = useFormatCurrency();
  return (value: number) => formatCurrency(value / 100);
}

export default useConvertCentsToEur;
